<template>

  <div>

    <Row>
      <Col :lg="8">
        <Form
          ref="formData"
          :model="formData"
          :rules="rules"
        >
          <!--Key-->
          <FormItem prop="encryptedKey">
            <Input
              v-model="formData.encryptedKey"
              class="border_30"
              type="text"
              placeholder="Введите ключ"
              size="large"
              v-mask="'XXXX-XXXX-XXXX-XXXX'"
            >
            </Input>
          </FormItem>

          <FormItem prop="cashId">
            <Select @on-select="selectCash" placeholder="Выберите кассу">
              <Option v-for="item in cashes" :key="item.cashId" :value="item.cashId">
                {{item.name}}
              </Option>
            </Select>
          </FormItem>


          <Button type="info" style="width: 100%"
                  @click="activate"
          :disabled="!formData.cashId || formData.encryptedKey.length < 19">
            Активировать кассу
          </Button>
        </Form>

        <Modal
          footer-hide="true"
          v-model="modal"
          title="">
          <h3 class="mb-40">Уведомление</h3>

          <p class="fs-16 mb-30">{{activateResponse}}</p>

          <Row type="flex" justify="end">
            <Button type="error" @click="modal = false">Закрыть</Button>
          </Row>
        </Modal>


      </Col>
    </Row>
  </div>
</template>

<script>

    import { mask } from "vue-the-mask";
    import {base_url} from "../../http";
    import {server_addr} from "../../http";


    export default {
        directives: {
            mask
        },
        data() {
            return {
                cashes: [],

                validForm: false,
                isChanged: false,
                modal: false,
                activateResponse: '',
                error: true,


                formData: {
                    cashId: "",
                    encryptedKey: "",
                },

                rules: {
                    encryptedKey: [
                        {
                            required: true,
                            message: "Пожалуйста, введите ключ",
                            trigger: "blur"
                        },
                        {
                            min: 19,
                            message: "Пожалуйста, введите ключ в формате хххх-хххх-хххх-хххх",
                            trigger: "blur"
                        }
                    ]
                },



            };
        },


        // Загружаем данные для таблицы
        methods: {
            isValidForm() {
                this.$refs.formData.validate(valid => {
                    this.validForm = valid;
                });
            },
            fetchData: function () {
                let url = base_url + "/proxy/cashboxes/";
                this.$http
                    .get(url)
                    .then(result => {
                        this.cashes = result.data;
                    })
            },


            activate: function () {
                this.$refs.formData.validate(valid => {
                    if(valid) {
                        const url = server_addr + "/proxy_/billing/v1/licenseKeys/activate";
                        this.$http
                            .post(url, {
                                "encryptedKey": this.formData.encryptedKey,
                                "cashId": this.formData.cashId,
                            })
                            .then(response => {
                                this.error = false;
                                this.activateResponse = "Касса " + response.data.cashbox.name + " активирована на " + response.data.duration + " " + response.data.durationUnit.name

                            })
                            .finally(() => {
                                if(this.error) {
                                    this.activateResponse = 'Выбранный ключ не найден'
                                }
                                this.modal  = true
                            })
                            // .catch(error => {
                            //     console.log('error' + error);
                            //     if(error) {
                            //         return this.$Notice.open({
                            //             title: 'Уведомление',
                            //             desc: 'Выбранный ключ не найден'
                            //         });
                            //     }
                            //
                            // })

                    }
                });

            },

            selectCash: function (id) {
                this.formData.cashId = id;
            }







        },
        mounted: function () {
            this.fetchData();
        }
    };


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/apps/payment/licenseKeys.vue